import { textConstants } from 'constants/texts';

export const createHashString = (value: string, prefix = 'hashed|') =>
  value ? `${prefix}${value}` : textConstants.notAvailaible;
